import React from 'react'
import { FaCircleDot } from "react-icons/fa6";
const Home = () => {
  return (
    <div class='home-div1'>
        <div class='home-div'>
           {/* <h1 class='home-h'>Home</h1> */}
        </div>
        <h1 class='home-h1 mt-3'>Protecting lives and property through reliable fire safety engineering solutions.</h1>
        <p class='home-p'>RJ Engineering – Engineering Safety, Protecting Lives.</p>
        <div class='container'>
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <h2 class='home-h2 mt-5'>INTRODUCTION</h2>
                    <p class='home-para'>R J Engineering is a Mechanical,Electrical,Plumbing and Fire Protection Service contracting company in Bengaluru,specializing in design,build,construct,supply,install,service,upgrade,maintenance of electro-mechanical systems & networks,utilities and equipment.We provide the latest Technology and equipment allowing us to give our customers the best services possible.We also do a follow
                    up on all clients to ensure that all equipment supplied is efficiently running and serviced on time.We have grown out of the need of ensuring safety and professional guidance to the industries and commercial buildings for safer and proper usage of all fire and industrial safety equipment.
                    </p>
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <img src='./Images/img1.jpg' class='home-img mt-5' alt='' />
                </div>
            </div>
        </div>
        <div class='container'> 
           <div class='row'>
               
                <h2 class='home-h2 mt-5'>Few of our business related activities are</h2>
                <div class='col-12 col-sm-12 col-md-4 col-lg-4 mt-3'>
                    
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Fire Safety Works</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Piping & plumbing works</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Fabrication Works</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Electrical Networking & Works </span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>AMC</span></p>
                </div>
                <div class='col-12 col-sm-12 col-md-4 col-lg-4 mt-3'>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Excavation</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>HVAC works</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Ducting & Thermal Insulations Works</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Industrial Installations Works</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Residential & Housing</span></p>
                </div>
                <div class='col-12 col-sm-12 col-md-4 col-lg-4 mt-3'>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Commercial & Businesses</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Administrative & Organizations</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Industrial & Factorial</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Sites & Open Areas</span></p>
                    <p><FaCircleDot class='icon1'/><span class='home-para1 ms-2'>Trade Centers & Mall,Hyper</span></p>
                </div>
           </div>
        </div>
        <div class='home-hr'>
            <h1 class='home-h3 mt-5'>Why Choose Us</h1>
        </div>
        <div>
            <p class='home-para1 mt-3'>At RJ Engineering Fire Protection & Safety, we are committed to delivering reliable and advanced fire safety solutions to protect lives, property, and businesses. Our focus on quality, safety standards, and customer satisfaction makes us a trusted partner for fire protection services.</p>
        </div>
        <div class='container'>
            <div class='row'>
               <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                  <h3 class='home-head'>1. Experienced Professionals</h3>
                  <p class='home-par'>Our team consists of trained engineers and fire safety experts with strong experience in installing and maintaining fire protection systems.</p>
                  <h3 class='home-head'>2. High-Quality Fire Safety Equipment</h3>
                  <p class='home-par'>We supply and install certified fire safety equipment including fire extinguishers, fire alarms, hydrant systems, and sprinkler systems.</p>
                  <h3 class='home-head'>3. Compliance with Safety Standards</h3>
                  <p class='home-par'>All our installations follow industry safety standards and fire department regulations to ensure maximum protection.</p>
                  <h3 class='home-head'>4. Customized Safety Solutions</h3>
                  <p class='home-par'>Every building has different safety needs, so we design fire protection systems tailored to your property.</p>
               </div>
               <div class='col-12 col-sm-12 col-md-6 col-lg-6'>
                  <h3 class='home-head'>5. Complete Fire Protection Solutions</h3>
                  <p class='home-par'>From fire safety audits to system installation and maintenance, we provide end-to-end fire protection services.</p>
                  <h3 class='home-head'>6. Quick Response & Reliable Support</h3>
                  <p class='home-par'>Our team is ready to respond quickly to service requests and emergency situations to keep your premises safe.</p>
                  <h3 class='home-head'>7. Affordable & Customized Solutions</h3>
                  <p class='home-par'>We offer cost-effective fire safety systems tailored to the specific needs of residential, commercial, and industrial properties.</p>
                  <h3 class='home-head'>8. Customer Satisfaction</h3>
                  <p class='home-par'>We prioritize long-term relationships by providing dependable service and ongoing support to all our clients.</p>
               </div>
               <h3 class='home-head mt-5'>Your Safety Is Our Priority.</h3>
               <p class='home-par'>📞 Contact us today for professional fire protection solutions.</p>
               <button class="button">Get in Touch</button>
            </div>
        </div>
       
    </div>
  )
}

export default Home